module.exports = __webpack_public_path__ + "img/love_invest_bg@3x.fddece4a.png";